module.exports = __webpack_public_path__ + "img/doctor-1.b5eccbee.png";